import { Component } from 'react';
import { RelatedLink } from '../../../types/site-urls';
import styles from './related-links.component.module.scss';
import { groupBy } from '../../../utils/lodash-min';
import { StringUtils } from '../../../utils/string-utils';


interface RelatedLinksComponentProps {
    relatedLinks: RelatedLink[];
}
export class RelatedLinksComponent extends Component<RelatedLinksComponentProps> {
    relatedLinks: { title: string; links: RelatedLink[]; }[];

    constructor(props: RelatedLinksComponentProps) {
        super(props);
        const groups = groupBy(this.props.relatedLinks, (v) => v.converterType.type);
        this.relatedLinks = Object.keys(groups).map(k => {
            return {
                title: StringUtils.capitalizeFirstLetter(k),
                links: groups[k]
            }
        }).sort().reverse()

    }

    componentDidCatch(err) {
        console.log(err);
    }

    render() {
        return <div className="card section text-left" >
            <div className='row'>
                {
                    this.relatedLinks.map((v) => {
                        return <div className='col-12 col-md-6 mb-3' key={v.title}>
                            <h5>Related {v.title} tools</h5>
                            <ol className={styles["related-links"]}>
                                {
                                    v.links.filter(link => link.converterType)
                                        .map((link, index) => <li key={`${index}`}><a href={link.url}>
                                            {link.converterType.title}</a></li>)

                                }
                            </ol>
                        </div>
                    })
                }
            </div>
        </div >
    }
}